<div class="account-selection-container">
  <section>
    <app-loading *ngIf="isLoading" />
    <img src="assets/images/svg/logo.svg" alt="Logo" width="229" height="50" />
    <h1 class="title">
      {{ 'Select an account to continue' | translate }}
    </h1>
    <mat-selection-list #selectionList [multiple]="false">
      @for (account of accounts; track account.appTypeId) {
        <mat-list-item (click)="onSelect(account)">
          <span class="account-info">
            <span class="account-type">{{ account.appTypeName }}</span>
            <span class="account-name">{{ account.displayName }}</span>
          </span>
          <mat-icon class="ml-2">chevron_right</mat-icon>
        </mat-list-item>
      }
    </mat-selection-list>
  </section>
</div>
